<template>
  <transition name="fade">
    <div class="ui-prompt" v-show="showPrompt">{{ msg }}</div>
  </transition>
</template>

<script setup>
// 全局 toast: 挂在 App.vue 顶层一次即可, 任何位置调 usePrompt().showPrompt(msg) 触发
import { ref, watch } from 'vue'
import { useUiStore } from '@/store'

defineOptions({ name: 'UiPrompt' })

const uiStore = useUiStore()
const showPrompt = ref(false)
const msg = ref('')
let hideTimer = null

watch(
  () => uiStore.promptStatus,
  ({ message, duration }) => {
    if (!message) return
    clearTimeout(hideTimer)
    msg.value = message
    showPrompt.value = true
    // 只切显隐, 不清 msg: v-show + fade transition 期间元素仍在, msg 清空会露出"空方块淡出"的视觉
    // (msg 会在下次 showPrompt 被新消息覆盖, 不用主动清)
    hideTimer = setTimeout(() => {
      showPrompt.value = false
    }, duration ?? 1500)
  },
  { deep: true }
)
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// position: fixed 相对 viewport 定位, z-index 拉到最上层, 保证在所有 modal / 抽屉之上
.ui-prompt {
  padding: 10px 30px;
  background-color: rgba(31, 31, 31, 0.8);
  border-radius: 48px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  color: #fff;
  text-align: center;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  white-space: nowrap;
  pointer-events: none;
}
</style>
